import * as React from "react"
const SvgComponent = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={25}
        height={24}
        cursor="pointer"
        fill="none"
        {...props}
    >
        <rect width={24} height={24} x={0.5} fill="#005586" rx={12} />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="m8.5 10 4 4 4-4"
        />
    </svg>
)
export default SvgComponent
